module.exports = __webpack_public_path__ + "img/credential1.eb182fcd.png";